const normativeInstrutions = [
    {
        "description": "Instrução Normativa nº7",
        "value": "IN07"
    }
]

class NormativeInstrutions {
    static getNormativeInstrutions() {
        return normativeInstrutions
    }
}
export default NormativeInstrutions;



// WEBPACK FOOTER //
// ./src/data/NormativeInstructions.js